import React, { useContext } from 'react'
import { StateContext } from '../../services/StateService'
import CtaTypeEnum from '../../../common/constants/CtaTypeEnum'
import PostPurchaseForm from './PostPurchaseForm'
import PostPurchaseWidget from './PostPurchaseWidget'

const PostPurchaseZone = () => {
    const { postPurchaseZone, richContent } = useContext(StateContext)
    const hasWidget = !!postPurchaseZone?.postPurchaseWidget
    const hasForm = !!richContent?.postPurchaseForm

    if (!hasWidget && !hasForm) {
        return null
    }

    return (
        <div id={CtaTypeEnum.POST_PURCHASE_FORM}>
            {hasWidget && <PostPurchaseWidget />}
            {hasForm && <PostPurchaseForm />}
        </div>
    )
}

export default PostPurchaseZone
